import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Heading } from "@chakra-ui/react";
import { CONCEIVE_SUPPORT_EMAIL } from "~/constants";
import { useSignOut } from "~/hooks/useSignOut";

export const DuplicatePhone: FC = () => {
  const { t } = useTranslation();
  const { handleSignOut } = useSignOut();

  const handleSignIn = () => {
    handleSignOut();
  };

  return (
    <Flex justify="center" w="full">
      <Flex align="center" direction="column" gap={6} maxW="25.875rem" w="full">
        <Heading variant="th-h4" textAlign="center">
          {t("onboarding.phonePage.duplicate.heading")}
        </Heading>
        <Flex
          bg="th.white"
          borderRadius="10px"
          boxShadow="0px 4px 30px 0px rgba(0, 0, 0, 0.05)"
          direction="column"
          gap={4}
          p={{ base: 4, md: 6 }}
          w="full"
        >
          <Button onClick={handleSignIn} size="th-md" variant="th-primary">
            {t("onboarding.phonePage.duplicate.signInCta")}
          </Button>
          <Button
            as="a"
            href={`mailto:${CONCEIVE_SUPPORT_EMAIL}`}
            size="th-md"
            target="_blank"
            variant="th-secondary"
          >
            {t("onboarding.phonePage.duplicate.contactCta")}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
